module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/advantages_1_4_1-f270d7e86e138b461388ab472d2346c9.png";